import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GoogleTagManagerService {
  private isLoaded = false;

  constructor() {}

  loadGTM(gtmId: string): void {
    if (this.isLoaded) {
      return; // Prevent loading the script multiple times
    }

    const gtmScript = document.createElement('script');
    gtmScript.async = true;
    gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    document.head.appendChild(gtmScript);

    const gtmDataLayer = document.createElement('script');
    gtmDataLayer.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', ${gtmId})
    `;
    document.head.appendChild(gtmDataLayer);

    this.isLoaded = true;
  }
}
